import React, { useEffect, useState, useMemo } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Assignment from "@material-ui/icons/Assignment";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import axios from "../../utils/axiosInstance";
import { MantineReactTable } from "mantine-react-table";
import { Box } from "@mantine/core";
import Button from "components/CustomButtons/Button.js";
import { IconDownload } from "@tabler/icons-react";
import { CircularProgress } from "@material-ui/core";
import { toast } from "react-toastify";

const useStyles = makeStyles(styles);

export default function WinnerLogs() {
  const [users, setUsers] = useState([]);
  const [loadingDownload, setLoadingDownload] = useState(false);
  console.log(users, "usersusers")
  const classes = useStyles();

  useEffect(() => {
    getData();
  }, []);
  const columns = useMemo(() => [
    {
      header: "Name",
      accessorKey: "firstName",
      size: 5,
    },
    {
      header: "Email",
      accessorKey: "emailAddress",
      size: 10,
    },
    {
      header: "Topic",
      accessorKey: "topic",
      size: 10,
    }, {
      header: "Subject",
      accessorKey: "subject",
      size: 10,
    },
    {
      header: "Details",
      accessorKey: "detail",
      size: 10,
    }

  ]);
  const getData = async () => {
    const token = localStorage.getItem("token");
    console.log(token);
    await axios
      .get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/enquirylog`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Access-Control-Allow-Origin": "*",
        },
      })
      .then((res) => {
        console.log(res);
        setUsers(res.data.data?.results);
      })

      .catch((err) => {
        console.log(err);
        if (err.response.data.message == "For security reasons, we locked your account.Please login to continue") {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      });
  };

  const handleDownload = async () => {
 
    setLoadingDownload(true);
    console.log("Downloading logs for lottery ID:");
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/enquiryLogDownload`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Access-Control-Allow-Origin": "*",
        },
       
        responseType: 'blob',
      });

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'Enquiry_Logs_List.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error?.response?.status === 403) {
        toast.error("You do not have permission to download this file.");
        return;
      } else {
        swal.fire({
          icon: "error",
          text: "error",
        });
      }
    } finally {
      setLoadingDownload(false); // hide loader
    }
  }
 
  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Enquiry Logs</h4>
          </CardHeader>
          <CardBody>
            <MantineReactTable
              columns={columns}
              enablePagination={false}
              enableFullScreenToggle={false}
              enableHiding={false}
              enableDensityToggle={false}
              enableFilters={false}
              enableColumnFilterModes
              initialState={{ showColumnFilters: true }}
              positionToolbarAlertBanner="bottom"
              data={users}
              renderTopToolbarCustomActions={({ table }) => (
                <Box
                  sx={{
                    display: "flex",
                    gap: "16px",
                    padding: "8px",
                    flexWrap: "wrap",
                  }}
                >
                  {loadingDownload ? (

                    <CircularProgress size={24} style={{ color: "black" }} />

                  ) : (
                    <Button
                      onClick={handleDownload}
                      style={{ marginLeft: "auto" }}
                      leftIcon={<IconDownload />}
                    >
                      Export All Rows
                    </Button>
                  )}
                </Box>
              )}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
